<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>
    <div v-if="open" class="fixed inset-0 z-40 bg-grey-50 overflow-auto">
      <div class="p-4 bg-white shadow relative z-10">
        <div class="container mx-auto flex justify-between items-center">
          <div class="text-lg text-dark font-bold">
            {{ $t('frontend_sites_account_modal_my_account') }}
          </div>
          <div class="flex">
            <gd-button @click="close" size="auto" class="px-5 h-10"
              >{{ $t('frontend_close') }}
            </gd-button>
          </div>
        </div>
      </div>
      <div
        class="overflow-y-auto custom-scrollbars h-full py-6 px-4"
        style="max-height: calc(100vh - 72px)"
      >
        <div class="container mx-auto">
          <div class="bg-white rounded mt-3 mb-8">
            <!-- <div class="px-4 py-3 border-solid border-grey-200 border-b">
              <h4 class="font-semibold text-grey-700">My Account Settings</h4>
              <div class="text-sm text-grey-700">
                You can configure your account settings here
              </div>
            </div> -->
            <gd-tabs
              :tabs="tabsNew"
              :tabs-with-errors="tabsWithErrors"
              ref="tabsNew"
            >
              <template slot="General Settings">
                <vertical-tabs
                  :tabs="generalSettingsTabs"
                  :wrapper-class="'pt-5 w-3/12 border-r border-grey-200 pb-10'"
                  :content-class="'py-5 px-6'"
                >
                  <template
                    :slot="$t('frontend_sites_account_modal_personal_info')"
                  >
                    <div class="flex">
                      <div class="w-3/4">
                        <div class="p-4">
                          <div
                            class="
                              text-sm text-grey-700
                              font-semibold
                              mt-4
                              mb-2
                            "
                          >
                            {{ $t('frontend_sites_account_modal_name') }}
                          </div>
                          <text-input v-model.trim="$v.name.$model" />
                          <div v-if="$v.name.$error">
                            <div
                              v-if="!$v.name.required"
                              class="
                                error
                                rounded
                                border border-pink-dark
                                mt-2
                                p-2
                              "
                            >
                              {{
                                $t(
                                  'frontend_sites_account_modal_name_is_required'
                                )
                              }}
                            </div>
                            <div
                              v-if="!$v.name.minLength"
                              class="
                                error
                                rounded
                                border border-pink-dark
                                mt-2
                                p-2
                              "
                            >
                              {{
                                $t(
                                  'frontend_sites_account_modal_name_must_have'
                                )
                              }}
                              {{ $v.name.$params.minLength.min }}
                              {{ $t('frontend_sites_account_modal_letters') }}.
                            </div>
                          </div>
                          <div
                            class="
                              text-sm text-grey-700
                              font-semibold
                              mt-4
                              mb-2
                            "
                          >
                            {{ $t('frontend_sites_account_modal_email') }}
                          </div>
                          <text-input v-model.trim="$v.email.$model" disabled />
                          <div class="text-sm text-grey-500 mt-2">
                            {{ $t('frontend_account_settings_chnage_email_address_contact_support') }}
                          </div>
                          <div v-if="$v.email.$error">
                            <div
                              v-if="!$v.email.required"
                              class="
                                error
                                rounded
                                border border-pink-dark
                                mt-2
                                p-2
                              "
                            >
                              {{
                                $t(
                                  'frontend_sites_account_modal_email_is_required'
                                )
                              }}
                            </div>
                            <div
                              v-if="!$v.email.minLength"
                              class="
                                error
                                rounded
                                border border-pink-dark
                                mt-2
                                p-2
                              "
                            >
                              {{
                                $t(
                                  'frontend_sites_account_modal_email_must_have'
                                )
                              }}
                              {{ $v.email.$params.minLength.min }}
                              {{ $t('frontend_sites_account_modal_letters') }}.
                            </div>
                            <div
                              v-if="!$v.email.email"
                              class="
                                error
                                rounded
                                border border-pink-dark
                                mt-2
                                p-2
                              "
                            >
                              {{
                                $t(
                                  'frontend_sites_account_modal_write_valid_email'
                                )
                              }}
                            </div>
                          </div>
                          <div
                            class="
                              text-sm text-grey-700
                              font-semibold
                              mt-4
                              mb-2
                            "
                          >
                            {{ $t('frontend_sites_account_modal_language') }}
                          </div>
                          <div class="cursor-pointer">
                            <Dropdown
                              :options="langs"
                              @change="onChange($event)"
                              class="w-full text-grey-700 h-10 large-dropdown"
                              v-model="locale"
                            />
                          </div>
                          <div
                            class="
                              flex
                              items-center
                              mt-4
                              text-sm
                              bg-grey-50
                              rounded-lg
                              p-2
                              text-grey-600
                              font-semibold
                            "
                          >
                            <InfoIcon class="mr-1" />
                            {{
                              $t(
                                'frontend_sites_account_modal_changes_to_your_account'
                              )
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="w-1/4 flex flex-col justify-center items-center"
                      >
                        <div
                          class="relative rounded-full overflow-hidden lg:block"
                        >
                          <img
                            v-if="profilePicture"
                            class="relative rounded-full w-40 h-40 object-cover"
                            :src="profilePicture"
                            alt=""
                          />
                          <img
                            v-else
                            class="relative rounded-full w-40 h-40 object-cover"
                            src="../assets/user.png"
                            alt=""
                          />
                          <label
                            for="user-photo"
                            class="
                              absolute
                              inset-0
                              w-full
                              h-full
                              bg-black bg-opacity-75
                              flex
                              items-center
                              justify-center
                              text-sm
                              font-medium
                              text-white
                              opacity-0
                              hover:opacity-100
                              focus-within:opacity-100
                              cursor-pointer
                            "
                            @click="openProfilePictureModal"
                          >
                            <span>{{ $t('frontend_change') }}</span>
                            <span class="sr-only">
                              {{ $t('frontend_user_photo') }}</span
                            >
                          </label>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template
                    :slot="$t('frontend_sites_account_modal_change_password')"
                  >
                    <div class="p-4">
                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_new_password') }}
                      </div>
                      <text-input
                        @keyup="checkPasswordLength"
                        v-model="password"
                      />
                      <div v-if="passwordFormatError">
                        <div
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_password_must_have_at_least_8_letters'
                            )
                          }}
                        </div>
                      </div>
                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{
                          $t('frontend_sites_account_modal_repeat_new_password')
                        }}
                      </div>
                      <text-input
                        @keyup="checkPasswordMatch"
                        v-model="passwordConfirm"
                      />
                      <div v-if="passwordMatchError">
                        <div
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_password_doesnot_match'
                            )
                          }}
                        </div>
                      </div>
                      <div
                        class="
                          flex
                          items-center
                          mt-4
                          text-sm
                          bg-grey-50
                          rounded-lg
                          p-2
                          text-grey-600
                          font-semibold
                        "
                      >
                        <InfoIcon class="mr-1" />
                        {{
                          $t(
                            'frontend_sites_account_modal_website_changes_to_your_account'
                          )
                        }}
                      </div>
                    </div>
                  </template>
                  <template
                    :slot="$t('frontend_sites_account_modal_contact_details')"
                  >
                    <div class="p-4">
                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_phone_number') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.phone.$model"
                      />
                      <div v-if="$v.contactDetails.phone.$error">
                        <div
                          v-if="!$v.contactDetails.phone.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_phone_number_must_have'
                            )
                          }}
                          {{ $v.contactDetails.phone.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_address') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.address.$model"
                      />
                      <div v-if="$v.contactDetails.address.$error">
                        <div
                          v-if="!$v.contactDetails.address.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_address_must_have')
                          }}
                          {{ $v.contactDetails.address.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_city') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.city.$model"
                      />
                      <div v-if="$v.contactDetails.city.$error">
                        <div
                          v-if="!$v.contactDetails.city.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_city_must_have')
                          }}
                          {{ $v.contactDetails.city.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_postal_code') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.postal_code.$model"
                      />
                      <div v-if="$v.contactDetails.postal_code.$error">
                        <div
                          v-if="!$v.contactDetails.postal_code.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_postal_code_must_have'
                            )
                          }}
                          {{
                            $v.contactDetails.postal_code.$params.minLength.min
                          }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_country') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.country.$model"
                      />
                      <div v-if="$v.contactDetails.country.$error">
                        <div
                          v-if="!$v.contactDetails.country.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_country_must_have')
                          }}
                          {{ $v.contactDetails.country.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_state') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.state.$model"
                      />
                      <div v-if="$v.contactDetails.state.$error">
                        <div
                          v-if="!$v.contactDetails.state.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_state_must_have')
                          }}
                          {{ $v.contactDetails.state.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>
                    </div>
                  </template>

                  <template
                    :slot="$t('frontend_sites_account_modal_socail_media')"
                  >
                    <div class="p-4">
                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_facebook') }}
                      </div>
                      <text-input
                        v-model.trim="$v.socialMedia.facebook.$model"
                      />
                      <div v-if="$v.socialMedia.facebook.$error">
                        <div
                          v-if="!$v.socialMedia.facebook.url"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_facebook_valid_url'
                            )
                          }}
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_twitter') }}
                      </div>
                      <text-input
                        v-model.trim="$v.socialMedia.twitter.$model"
                      />
                      <div v-if="$v.socialMedia.twitter.$error">
                        <div
                          v-if="!$v.socialMedia.twitter.url"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_twitter_valid_url')
                          }}
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_instagram') }}
                      </div>
                      <text-input
                        v-model.trim="$v.socialMedia.instagram.$model"
                      />
                      <div v-if="$v.socialMedia.instagram.$error">
                        <div
                          v-if="!$v.socialMedia.instagram.url"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{ $t('frontend_sites_enter_valid_url') }}
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_linkedin') }}
                      </div>
                      <text-input
                        v-model.trim="$v.socialMedia.linkedin.$model"
                      />
                      <div v-if="$v.socialMedia.linkedin.$error">
                        <div
                          v-if="!$v.socialMedia.linkedin.url"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{ $t('frontend_sites_enter_valid_url') }}
                        </div>
                      </div>
                    </div>
                  </template>

                  <template
                    :slot="$t('frontend_sites_account_modal_business_details')"
                  >
                    <div class="p-4">
                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_company') }}
                      </div>
                      <text-input
                        v-model.trim="$v.businessInfo.company_name.$model"
                      />
                      <div v-if="$v.businessInfo.company_name.$error">
                        <div
                          v-if="!$v.businessInfo.company_name.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_company_must_have')
                          }}
                          {{
                            $v.businessInfo.company_name.$params.minLength.min
                          }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sales_tax_id') }}
                      </div>
                      <text-input
                        v-model.trim="$v.businessInfo.tax_id.$model"
                      />
                      <div v-if="$v.businessInfo.tax_id.$error">
                        <div
                          v-if="!$v.businessInfo.tax_id.required"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_sales_tax_id_requires'
                            )
                          }}
                        </div>
                        <div
                          v-if="!$v.businessInfo.tax_id.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_tax_id_must_have')
                          }}
                          {{ $v.businessInfo.tax_id.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_website') }}
                      </div>
                      <text-input
                        v-model.trim="$v.businessInfo.website.$model"
                      />
                      <div v-if="$v.businessInfo.website.$error">
                        <div
                          v-if="!$v.businessInfo.website.url"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{ $t('frontend_sites_enter_valid_url') }}
                        </div>
                      </div>
                    </div>
                  </template>
                </vertical-tabs>
                <div class="flex -mt-2">
                  <div class="w-3/12 border-r border-grey-200"></div>
                  <div class="w-full flex justify-end px-6 py-5 border-solid border-grey-200 border-t">
                    <gd-button @click="update" primary size="auto" class="px-10 h-10"
                      >{{ $t('frontend_save') }}
                    </gd-button>
                  </div>
                </div>
              </template>
              <template slot="Domains">
                <div class="py-4">
                  <account-domains />
                </div>
              </template>
              <template slot="Plans">
                <div class="px-4 py-8">
                  <billing-plans />
                </div>
              </template>
              <template slot="Billing Settings">
                <div>
                  <div><account-billing /></div>
                </div>
              </template>
              <template slot="Developer">
                <div class="p-4">
                  <div class="text-sm text-grey-700 font-semibold mt-4 mb-2">
                    {{ $t('frontend_sites_account_modal_api_key') }}
                  </div>
                  <text-input
                    :selectAll="true"
                    :disabled="true"
                    v-model="apiKey"
                  />
                </div>
              </template>
              
              <template slot="Affiliate Settings">
                <AffiliateSettings />
              </template>
               <template slot="Integrations">
                <MyIntegrations />
              </template>
              <template slot="App Settings">
                <vertical-tabs
                  :tabs="appSettingtabs"
                  ref="appSettingtabs"
                  :wrapper-class="'pt-5 w-56 border-r border-grey-200 pb-10'"
                >
                  <template slot="GrooveSell Settings">
                    <vertical-tabs
                      :tabs="groovesellSettingtabs"
                      ref="groovesellSettingtabs"
                      :wrapper-class="'pt-5 w-56 border-r border-grey-200 pb-10'"
                    >
                      <template slot="Vendor Settings">
                        <VendorSettings />
                      </template>
                      <template slot="Payment Gateways">
                        <PaymentGateway />
                      </template>
                    </vertical-tabs>
                  </template>
                  <template slot="GrooveMail Settings">
                    <SenderSettings />
                  </template>
                  <template slot="GrooveVideo Settings">
                    <VideoSettings />
                  </template>
                </vertical-tabs>
              </template>
            </gd-tabs>
            <gd-modal
              ref="profileImageModal"
              name="profileImageModal"
              width="100%"
              height="100%"
            >
              <image-picker-without-modal
                :value="profilePicture"
                modal="true"
                remove="false"
                @close-modal="$refs.profileImageModal.close()"
                @selected="selectedProfilePicture"
              ></image-picker-without-modal>
            </gd-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@groovepages/gd-lib/api';
import Auth from '@groovepages/gd-lib/auth';
import Notify from '@groovepages/gd-lib/notify';
import { validationMixin } from 'vuelidate';
import { email, minLength, required, url } from 'vuelidate/lib/validators';
import AccountDomains from './AccountDomains';
import GdButton from './Button';
import Dropdown from './Dropdown';
import ImagePickerWithoutModal from './ImagePicker';
import ImagePicker from './ImagePickerModal';
import GdModal from './Modal';
import GdTabs from './Tabs';
import TextInput from './TextInput';
import InfoIcon from '../assets/info-icon.svg';
import BillingPlans from './AccountBilling';
import AccountBilling from './settings/billing-settings/account-billing/billing.vue';
import VerticalTabs from './VerticalTabs';
import VendorSettings from './settings/groovesell-settings/VendorSettings.vue';
import PaymentGateway from './settings/payment-gateway/PaymentGateway.vue';
import AffiliateSettings from './settings/groovesell-settings/AffiliateSettings.vue';
import SenderSettings from './settings/groovemail-settings/SenderSettings.vue';
import VideoSettings from './settings/groovevideo-settings/VideoSettings.vue';
import themeConfig from '../themeConfig.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import MyIntegrations from './MyIntegrations.vue';

export default {
  components: {
    Loading,
    AccountDomains,
    GdButton,
    GdTabs,
    TextInput,
    Dropdown,
    ImagePicker,
    ImagePickerWithoutModal,
    GdModal,
    InfoIcon,
    BillingPlans,
    AccountBilling,
    VerticalTabs,
    VendorSettings,
    PaymentGateway,
    AffiliateSettings,
    SenderSettings,
    VideoSettings,
    MyIntegrations,
  },
  mixins: [validationMixin],
  props: ['open'],
  watch: {
    open(newVal) {
      if (newVal) {
        this.init();
      }
    },
  },
  data() {
    return {
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      langs: [this.$t('frontend_english'), this.$t('frontend_portuguese')],
      locale: '',
      tabs: [
        this.$t('frontend_sites_account_modal_personal_info'),
        this.$t('frontend_sites_account_modal_change_password'),
        this.$t('frontend_sites_account_modal_contact_details'),
        this.$t('frontend_sites_account_modal_socail_media'),
        this.$t('frontend_sites_account_modal_business_details'),
        this.$t('frontend_sites_account_modal_api_key'),
        this.$t('frontend_sites_account_modal_domains'),
        this.$t('frontend_sites_account_modal_plan'),
      ],
      tabsNew: [
        'General Settings',
        'Domains',
        'Plans',
        'Billing Settings',
        'Developer',
        'Affiliate Settings',
        'Integrations',
        'App Settings',
      ],
      appSettingtabs: [
        'GrooveSell Settings',
        'GrooveMail Settings',
        'GrooveVideo Settings',
      ],
      groovesellSettingtabs: [
        'Vendor Settings',
        'Payment Gateways',
      ],
      generalSettingsTabs: [
        this.$t('frontend_sites_account_modal_personal_info'),
        this.$t('frontend_sites_account_modal_change_password'),
        this.$t('frontend_sites_account_modal_contact_details'),
        this.$t('frontend_sites_account_modal_socail_media'),
        this.$t('frontend_sites_account_modal_business_details'),
      ],
      
      tabsWithErrors: [],
      userId: '',
      name: '',
      email: '',
      profilePicture: '',
      businessInfo: {
        company_name: '',
        tax_id: '',
        website: '',
      },
      contactDetails: {
        phone: '',
        address: '',
        city: '',
        postal_code: '',
        country: '',
        state: '',
      },
      socialMedia: {
        facebook: '',
        twitter: '',
        instagram: '',
        linkedin: '',
      },
      password: '',
      passwordConfirm: '',
      error: '',
      passwordFormatError: false,
      passwordMatchError: false,
      apiKey: '',
    };
  },
  computed: {
    freeUser() {
      return this.$store.getters.isLiteUser;
    },
  },
  async created() {},
  validations: {
    name: {
      required,
      minLength: minLength(6),
    },
    email: {
      required,
      email,
      minLength: minLength(6),
    },
    contactDetails: {
      phone: {
        minLength: minLength(6),
      },
      address: {
        minLength: minLength(4),
      },
      city: {
        minLength: minLength(1),
      },
      postal_code: {
        minLength: minLength(4),
      },
      country: {
        minLength: minLength(1),
      },
      state: {
        minLength: minLength(1),
      },
    },
    socialMedia: {
      facebook: {
        url,
      },
      twitter: {
        url,
      },
      instagram: {
        url,
      },
      linkedin: {
        url,
      },
    },
    businessInfo: {
      company_name: {
        minLength: minLength(2),
      },
      tax_id: {
        minLength: minLength(2),
      },
      website: {
        url,
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    selectedProfilePicture(value) {
      this.profilePicture = value;
    },

    openProfilePictureModal() {
      console.log('inside open profile picture modal');
      this.$root.$emit('modal-open', 'profileImageModal');
    },

    init() {
      const page_lang = localStorage.getItem('lang');

      if (page_lang == null) {
        localStorage.setItem('lang', 'en');
        this.$root.$i18n.locale = 'en';
        this.locale = 'english';
      }

      if (page_lang == 'en') {
        this.locale = this.$t('frontend_english');
      } else {
        this.locale = this.$t('frontend_portuguese');
        this.$root.$i18n.locale = localStorage.getItem('lang');
      }

      const user = Auth.authenticatedUser() || {};

      this.userId = user.id;
      this.name = user.name;
      this.email = user.email;
      // this.features = user.features;
      if (user.metadata && user.metadata.hasOwnProperty('profile_picture')) {
        this.profilePicture = user.metadata.profile_picture;
      }

      if (user.metadata && user.metadata.hasOwnProperty('business_info')) {
        if (user.metadata.business_info.hasOwnProperty('company_name')) {
          this.businessInfo.company_name =
            user.metadata.business_info.company_name;
        }

        if (user.metadata.business_info.hasOwnProperty('tax_id')) {
          this.businessInfo.tax_id = user.metadata.business_info.tax_id;
        }

        if (user.metadata.business_info.hasOwnProperty('website')) {
          this.businessInfo.website = user.metadata.business_info.website;
        }
      }

      if (user.metadata && user.metadata.hasOwnProperty('social_media')) {
        if (user.metadata.social_media.hasOwnProperty('facebook')) {
          this.socialMedia.facebook = user.metadata.social_media.facebook;
        }

        if (user.metadata.social_media.hasOwnProperty('twitter')) {
          this.socialMedia.twitter = user.metadata.social_media.twitter;
        }

        if (user.metadata.social_media.hasOwnProperty('instagram')) {
          this.socialMedia.instagram = user.metadata.social_media.instagram;
        }

        if (user.metadata.social_media.hasOwnProperty('linkedin')) {
          this.socialMedia.linkedin = user.metadata.social_media.linkedin;
        }
      }

      if (user.metadata && user.metadata.hasOwnProperty('contact_details')) {
        if (user.metadata.contact_details.hasOwnProperty('phone')) {
          this.contactDetails.phone = user.metadata.contact_details.phone;
        }

        if (user.metadata.contact_details.hasOwnProperty('address')) {
          this.contactDetails.address = user.metadata.contact_details.address;
        }

        if (user.metadata.contact_details.hasOwnProperty('city')) {
          this.contactDetails.city = user.metadata.contact_details.city;
        }

        if (user.metadata.contact_details.hasOwnProperty('postal_code')) {
          this.contactDetails.postal_code =
            user.metadata.contact_details.postal_code;
        }

        if (user.metadata.contact_details.hasOwnProperty('country')) {
          this.contactDetails.country = user.metadata.contact_details.country;
        }

        if (user.metadata.contact_details.hasOwnProperty('state')) {
          this.contactDetails.state = user.metadata.contact_details.state;
        }
      }
      if (this.subDomain) {
        this.newSubDomain = this.subDomain;
      }

      if (user.api_key) {
        this.apiKey = user.api_key;
      } else {
        this.apiKey = this.$t('frontend_affiliate_index_NA');
      }
    },

    onChange() {
      if (this.locale == this.$t('frontend_portuguese')) {
        localStorage.setItem('lang', 'pt');
        this.$root.$i18n.locale = 'pt';
        this.locale = this.$t('frontend_portuguese');
      } else {
        localStorage.setItem('lang', 'en');
        this.$root.$i18n.locale = 'en';
        this.locale = this.$t('frontend_english');
      }
      setTimeout(() => {
        this.init();
      });
    },

    checkPasswordLength() {
      const containsUpper = new RegExp('(?=.*[a-z])');
      const containsLower = new RegExp('(?=.*[A-Z])');
      const containsNumber = new RegExp('(?=.*[0-9])');
      if (
        this.password &&
        (this.password.length < 8 ||
          !containsUpper.test(this.password) ||
          !containsLower.test(this.password) ||
          !containsNumber.test(this.password))
      ) {
        this.passwordFormatError = true;
      } else {
        this.passwordFormatError = false;
      }
      this.passwordMatchError = false;
    },

    checkPasswordMatch() {
      if (this.passwordConfirm && this.passwordConfirm !== this.password) {
        this.passwordMatchError = true;
      } else {
        this.passwordMatchError = false;
      }
    },

    close() {
      this.$emit('close');
    },

    showError(e) {
      if (e.response && e.response.data.errors) {
        return Notify.fail(
          e.response.data.message,
          e.response.data.errors.map(({ message }) => message).join('. ')
        );
      }
      return Notify.fail(e.message);
    },

    update() {
      this.$v.$touch();

      if (this.$v.$invalid || this.password !== this.passwordConfirm) {
        this.passwordFormatError = false;
        this.passwordMatchError = false;
        if (this.password && this.password.length < 8)
          this.passwordFormatError = true;
        if (this.password && this.password !== this.passwordConfirm)
          this.passwordMatchError = true;

        this.tabsWithErrors = [];

        if (this.$v.name.$invalid || this.$v.email.$invalid) {
          this.tabsWithErrors.push(
            this.$t('frontend_sites_account_modal_personal_info')
          );
        }

        if (this.$v.contactDetails.$invalid) {
          this.tabsWithErrors.push(
            this.$t('frontend_sites_account_modal_contact_details')
          );
        }

        if (this.$v.socialMedia.$invalid) {
          this.tabsWithErrors.push('Social Media');
        }

        if (this.$v.businessInfo.$invalid) {
          this.tabsWithErrors.push(
            this.$t('frontend_sites_account_modal_business_details')
          );
        }

        if (this.password !== this.passwordConfirm) {
          this.tabsWithErrors.push(
            this.$t('frontend_sites_account_modal_change_password')
          );
        }
      } else {
        this.showLoader();
        this.tabsWithErrors = [];
        this.passwordFormatError = false;
        this.passwordMatchError = false;
        const data = {
          name: this.name,
          email: this.email,
        };

        if (this.password) data.password = this.password;

        const self = this;
        api
          .post(
            `${window.gdEnv.VUE_APP_API_URL}/groovedigital/auth/users/update-user`,
            data
          )
          .then(() => {
            const metadata = {
              business_info: self.businessInfo,
              social_media: self.socialMedia,
              contact_details: self.contactDetails,
            };

            if (this.profilePicture && this.profilePicture != '') {
              metadata.profile_picture = this.profilePicture;
            }

            api
              .post(
                `${window.gdEnv.VUE_APP_API_URL}/groovedigital/auth/users/update-meta/${this.userId}`,
                metadata
              )
              .then((result) => {
                Auth.updateMeta(result);
                Notify.success('Details Updated');
                this.hideLoader();
              })
              .catch((err) => {
                Notify.fail(err);
              });

            Auth.updateDetails(this.name, this.email);
          })
          .catch((err) => {
            Notify.fail(err);
          });
      }
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style lang="scss">
.vclient-table {
  .VueTables__search .VueTables__search-field {
    display: none;
  }
  .VueTables--client table {
    overflow: auto !important;
  }
  .VueTables__heading {
    color: #8f92ab;
  }
  .VueTables__sort-icon {
    color: #8f92ab;
    margin-left: 8px;
  }
  td {
    font-weight: 200;
  }
  .VueTables__child-row-toggler--closed::before {
    content: url("data:image/svg+xml; utf8, <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='m3.707031 7l-.707031.707031 6.125 6.125 1.875 1.875 1.875-1.875 6.125-6.125-.707031-.707031-6.125 6.125-1.167969 1.167969-1.167969-1.167969-6.125-6.125' /></svg>");
    padding-right: 3px;
    vertical-align: middle;
  }
  .VueTables__child-row {
    text-align: center;
    border-bottom: 1px solid #ddd;
    border-left: 5px solid #fd6481;
  }
  .VueTables__child-row-toggler--open::before {
    content: url("data:image/svg+xml; utf8, <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='m3.707031 1044.3622l-.707031-.707 6.125-6.125 1.875001-1.875 1.875 1.875 6.125 6.125-.707032.707-6.125-6.125-1.167968-1.168-1.167969 1.168-6.125 6.125' transform='translate(0-1030.3622)'/></svg>");
    padding-right: 3px;
    vertical-align: middle;
  }
  .VueTables__table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
  }
  .VueTables__row {
    border-bottom: 1px solid #ddd;
    td {
      &:first-child {
        width: 30%;
      }
      &:nth-child(2) {
        width: 40%;
      }
      &:nth-child(3) {
        width: 19%;
      }
      &:last-child {
        width: 11%;
      }
    }
  }
  .VueTables__table th,
  td {
    text-align: left;
    padding: 16px;
  }
  tr.VueTables__child-row > td {
    padding: 0px !important;
  }
  thead {
    border-bottom: 1px solid #ddd;
  }
  .vue-pagination-ad {
    text-align: center;
  }
  .VueTables__limit {
    display: none;
  }
  .VuePagination__count {
    display: none;
  }
  .expandIcon {
    display: none;
  }
  .VuePagination__pagination {
    display: flex;
    margin-top: 10px;
    justify-content: flex-end;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .VuePagination__pagination-item {
    padding-left: 2px;
    padding-right: 2px;
  }
  .VueTables__search-field {
    display: flex;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #dcdcea;
  }
  .VueTables__search__input {
    border: 1px solid #eee;
    border-radius: 5px;
    margin-left: 10px;
    font-size: 14px;
    padding: 6px !important;
  }
}
</style>
